export const subjectColors: Record<
  string,
  { bg: string; text: string; border: string }
> = {
  'All Subjects': {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    border: 'border-black/5',
  },
  Mathematics: {
    bg: 'bg-cyan-100',
    text: 'text-cyan-700',
    border: 'border-black/5',
  },
  English: {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    border: 'border-black/5',
  },
  Physics: {
    bg: 'bg-cyan-100',
    text: 'text-cyan-700',
    border: 'border-black/5',
  },
  Chemistry: {
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-black/5',
  },
  Biology: {
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-black/5',
  },
  'Environmental Science': {
    bg: 'bg-orange-100',
    text: 'text-orange-700',
    border: 'border-black/5',
  },
  'Computer Science': {
    bg: 'bg-yellow-100',
    text: 'text-yellow-700',
    border: 'border-black/5',
  },
  'Social Sciences': {
    bg: 'bg-pink-100',
    text: 'text-pink-700',
    border: 'border-black/5',
  },
  'World Language': {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    border: 'border-black/5',
  },
  Art: {
    bg: 'bg-rose-100',
    text: 'text-rose-700',
    border: 'border-black/5',
  },
  Music: {
    bg: 'bg-rose-100',
    text: 'text-rose-700',
    border: 'border-black/5',
  },
  Others: {
    bg: 'bg-indigo-100',
    text: 'text-indigo-700',
    border: 'border-black/5',
  },
  Economics: {
    bg: 'bg-lime-100',
    text: 'text-lime-700',
    border: 'border-black/5',
  },
};

export const mySubjectColors: Record<
  string,
  { bg: string; text: string; border: string }
> = {
  ...subjectColors,
};
